<ng-template #listTemplate let-visibleAdmins>
  <div
    *ngFor="let admin of visibleAdmins; trackBy: trackById"
    class="result"
    [class.disabled]="disabledIds[admin.id]"
  >
    <rt-group variant="horizontal" (click)="toggleAssignment(admin)">
      <span
        [rtTooltip]="disabledIds[admin.id] && lockedAssignmentsTooltip"
        [rtTooltipMaxWidth]="245"
        [rtTooltipHasTextAlignCenter]="true"
      >
        <rt-checkbox
          [disabled]="disabledIds[admin.id]"
          [value]="$any(admin.id)"
          [checked]="selectedIds.has(admin.id)"
          (click)="toggleAssignment(admin)"
        >
        </rt-checkbox>
      </span>
      <rt-avatar
        [type]="'image'"
        [size]="'base'"
        [shape]="'oval'"
        [imageSrc]="admin.photoThumbUrl"
      ></rt-avatar>
      <div margin-left-small layout-vertical>
        <rt-heading>{{ admin.firstName }} {{ admin.lastName }}</rt-heading>
        <span>{{ admin.email }}</span>
      </div>
    </rt-group>
    <rt-divider></rt-divider>
  </div>
</ng-template>

<rt-dialog-header
  [heading]="heading"
  [subheading]="showCountBeforeSubheading ? selectedIds.size + ' ' + subheading : subheading"
>
</rt-dialog-header>

<rt-dialog-body>
  <rt-spinner *ngIf="loadingAdmins"></rt-spinner>

  <rt-box *ngIf="!loadingAdmins" variant="vertical background no-padding">
    <div class="search">
      <rt-form-field>
        <rt-input
          variant="rounded"
          [placeholder]="'app.common.placeholders.search.team_members.other' | translate"
          [autoFocus]="true"
          [formControl]="searchControl"
          [hasClearButton]="true"
          (reset)="cancelSearch()"
        >
          <rt-icon prefix name="search"></rt-icon>
        </rt-input>
      </rt-form-field>

      <rt-group variant="horizontal" class="select-options">
        <rt-button variant="plain" (click)="selectAll()">
          {{ 'app.common.all' | translate }}
        </rt-button>
        <rt-button variant="plain" (click)="selectNone()">
          {{ 'app.common.none' | translate }}
        </rt-button>
      </rt-group>
    </div>

    <rt-divider variant="line"></rt-divider>

    <ng-container *ngIf="admins | rtAdminFilter : searchControl.value; let filteredAdmins">
      <div
        *ngIf="filteredAdmins.length > 20"
        class="results results--virtual"
        virtualScroller
        [items]="admins | rtAdminFilter : searchControl.value"
        [bufferAmount]="10"
        [scrollAnimationTime]="0"
        [scrollThrottlingTime]="10"
        [executeRefreshOutsideAngularZone]="true"
        (vsUpdate)="onVirtualScrollUpdate($event)"
      >
        <ng-template
          [ngTemplateOutlet]="listTemplate"
          [ngTemplateOutletContext]="{ $implicit: virtualScrollAdmins }"
        ></ng-template>
      </div>
      <div *ngIf="filteredAdmins.length <= 20 && filteredAdmins.length > 0" class="results">
        <ng-template
          [ngTemplateOutlet]="listTemplate"
          [ngTemplateOutletContext]="{ $implicit: filteredAdmins }"
        ></ng-template>
      </div>
      <rt-empty-state
        *ngIf="!filteredAdmins.length"
        variant="small"
        [icon]="'search'"
        [title]="'app.common.no_results_found' | translate"
      >
        <rt-button variant="secondary" (click)="cancelSearch()">
          {{ 'app.assignments.editor.clear_search' | translate }}
        </rt-button>
      </rt-empty-state>
    </ng-container>
  </rt-box>
</rt-dialog-body>

<rt-dialog-footer>
  <rt-button *ngIf="!loading" variant="plain" (click)="cancel()">
    {{ 'app.common.cancel' | translate }}
  </rt-button>
  <rt-button variant="primary" [disabled]="!isValid()" [loading]="loading" (click)="submit()">
    {{ 'app.common.save' | translate }}
  </rt-button>
</rt-dialog-footer>
